<template>
  <v-data-table
    :headers="userDataTableHeaders"
    :items="userList"
    class="elevation-1"
    :loading="isLoadingUser"
    :search="searchUser"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
  >
    <!--:server-items-length ="totalRows"
    :options="currentOptions"
    @update:options="updateOptions"-->
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('user_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchUser"
          append-icon="mdi-magnify"
          :label="$t('user_search_label')"
          single-line
          hide-details
          clearable
          ><!--@input="getUser"--></v-text-field
        >
        <v-dialog v-model="isShowEditUserDialog" max-width="500px" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
              {{ $t('user_new_btn') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ userDialogTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <ValidationObserver ref="user">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('user_username')"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedUser.UserName"
                          :disabled="editedUserIndex !== -1"
                          autocomplete="username"
                          @keyup.enter="focusNextInput"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('user_username') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('user_role')"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          :items="roleList"
                          v-model="editedUser.Roles"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          small-chips
                          multiple
                          item-text="Name"
                          item-value="Name"
                          autocomplete="off"
                          return-object
                          @keydown.enter="setKeyDownAutocomplete"
                          @keyup.enter="setKeyUpAutocomplete"
                          ref="roleAutocomplete"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('user_role') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('user_role')"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedUser.NickName"
                          autocomplete="off"
                          :label="$t('user_nickname')"
                          @keyup.enter="focusNextInput"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('user_nickname') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <v-text-field
                        v-model="editedUser.Email"
                        :label="$t('user_email')"
                        autocomplete="off"
                        @keyup.enter="focusNextInput"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedUserIndex === -1">
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('user_pass')"
                        :rules="{ required: true, min: 6 }"
                        v-slot="{ errors }"
                        v-if="editedUserIndex === -1"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="value = !value"
                          :type="value ? 'password' : 'text'"
                          v-model="editedUser.Password"
                          :error-messages="errors[0]"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('user_pass') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedUserIndex !== -1">
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <v-checkbox
                        v-model="checkUpdatePassword"
                        :label="$t('user_update_password')"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('user_pass')"
                        :rules="{ required: true, min: 6 }"
                        v-slot="{ errors }"
                        v-if="editedUserIndex !== -1 && checkUpdatePassword"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="value = !value"
                          :type="value ? 'password' : 'text'"
                          v-model="editedUser.Password"
                          :label="$t('user_pass')"
                          v-if="checkUpdatePassword"
                          :error-messages="errors[0]"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('user_pass') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedUser"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedUser"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          v-if="isShowDeleteUserDialog"
          :isAllTextFieldDisable="isAllTextFieldDisable"
          :isLoadingSaveBtn="isLoadingSaveBtn"
          :isShowDeleteDialog="isShowDeleteUserDialog"
          :deleteMessage="'user_delete_dialog_message'"
          @closeDelete="closeDeletedUser"
          @confirmDelete="confirmDeleteUser"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="editUserBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="deleteUserBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:[`item.Roles`]="{ item }">
      {{ turnData(item.Roles) }}
    </template>
  </v-data-table>
</template>

<script>
import { HttpUser, HttpRole } from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { min } from 'vee-validate/dist/rules'
import DeleteDialog from '@/components/DeleteDialog.vue'
extend('min', min)

export default {
  components: { DeleteDialog },
  name: 'User',
  data: () => ({
    isShowEditUserDialog: false,
    userList: [],
    editedUserIndex: -1,
    searchUser: '',
    editedUser: {
      UserName: '',
      Password: '',
      Email: '',
      Roles: [],
      NickName: ''
    },
    defaultUser: {
      UserName: '',
      Password: '',
      Email: '',
      Roles: [],
      NickName: ''
    },
    checkUpdatePassword: false,
    isLoadingUser: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    userSource: null,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    roleList: [],
    value: true,
    isShowDeleteUserDialog: false,
    tempRoles: []
  }),
  async mounted () {
    this.getUser()
    this.getRole()
    // this.getTotalCount()
  },
  computed: {
    userDataTableHeaders () {
      return [
        { text: this.$t('user_username'), align: 'start', value: 'UserName' },
        { text: this.$t('user_nickname'), align: 'start', value: 'NickName' },
        { text: this.$t('user_email'), align: 'start', value: 'Email' },
        { text: this.$t('user_role'), align: 'start', value: 'Roles' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    userDialogTitle () {
      return this.editedUserIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempRoles = this.editedUser.Roles
    },
    setKeyUpAutocomplete (event) {
      this.$refs.roleAutocomplete.isMenuActive = false
      this.$refs.roleAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedUser.Roles = this.tempRoles
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnData (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)

          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    // async getTotalCount () {
    //   if (this.isUpdateEventTotal) {
    //     let param = {
    //       searchUser: this.searchUser
    //     }
    //     let response = await HttpItem.GetsearchUserCount(param)
    //     this.totalRows = response.status === 200 ? response.data.Data : 0
    //   }
    // },
    // updateOptions (val) {
    //   this.currentOptions = val
    //   this.isUpdateEventTotal = false
    //   this.getUser(val)
    // },
    async getRole () {
      let response = await HttpRole.GetRole()
      this.roleList = response.status === 200 ? response.data.Data : []
      var index = 0
      for (var element of this.roleList) {
        if (element.Name === 'God') {
          this.roleList.splice(index, 1)
          break
        }
        index++
      }
    },

    async getUser () {
      this.isLoadingUser = true
      let response = await HttpUser.GetUsers()
      this.isLoadingUser = false
      this.userList = response.status === 200 ? response.data.Data : []
      var index = 0
      for (var element of this.userList) {
        if (element.UserName === 'God') {
          this.userList.splice(index, 1)
          break
        }
        index++
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    editUserBtn (item) {
      this.value = true
      this.checkUpdatePassword = false
      this.editedUserIndex = this.userList.indexOf(item)
      this.editedUser = Object.assign({}, item)
      this.isShowEditUserDialog = true
    },
    closeEditedUser () {
      this.isLoadingUser = false
      this.isShowEditUserDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultUser)
        this.editedUserIndex = -1
      })
    },

    async saveEditedUser () {
      const isValid = await this.$refs.user.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingUser = true
        if (this.editedUserIndex !== -1) {
          await HttpUser.UpdateUser(this.editedUser)
        } else {
          await HttpUser.AddUser(this.editedUser)
        }

        await this.getUser()
        this.closeEditedUser()
      }
    },
    deleteUserBtn (item) {
      this.value = true
      this.checkUpdatePassword = false
      this.editedUser = JSON.parse(JSON.stringify(item))
      this.isShowDeleteUserDialog = true
    },
    async confirmDeleteUser () {
      this.isLoadingUser = true
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      let response = await HttpUser.DeleteUser(this.editedUser.Id)
      if (response.status === 200) {
        await this.getUser()
        this.closeDeletedUser()
      }
    },
    closeDeletedUser () {
      this.isLoadingUser = false
      this.isShowDeleteUserDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        this.editedUser = JSON.parse(JSON.stringify(this.defaultUser))
      })
    }
  }
}
</script>
